/**
 * ErrorBoundary (anti-page-blanche, audit M1 §7.1).
 *
 * Composant classe (getDerivedStateFromError + componentDidCatch). Placé HORS
 * des providers dans index.js : le fallback est AUTONOME (styles inline, aucune
 * dépendance provider/i18n, texte FR statique) pour ne pas re-crasher si un
 * provider est la source de l'erreur. Une 2e boundary est montée dans Layout
 * (via la prop `fallback`) pour qu'un crash de page préserve la coquille nav.
 *
 * Sans cette barrière, tout throw en rendu démonte la racine React = page blanche.
 */
import React from 'react';
import { reportClientError } from '../utils/clientTelemetry';

const wrap = {
  minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
  padding: '24px', fontFamily: 'system-ui, -apple-system, sans-serif',
  background: '#f8fafc', color: '#0f172a',
};
const card = { maxWidth: '440px', textAlign: 'center' };
const btn = {
  marginTop: '20px', padding: '10px 22px', border: 'none', borderRadius: '8px',
  background: '#2563eb', color: '#fff', fontSize: '15px', fontWeight: 600, cursor: 'pointer',
};

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Télémétrie une fois (dédup interne par message/session). Jamais bloquant.
    reportClientError({
      message: (error && error.message) || String(error),
      stack: `${(error && error.stack) || ''}\n${(info && info.componentStack) || ''}`,
    });
  }

  render() {
    if (this.state.hasError) {
      // Layout fournit un fallback « coquille préservée » ; sinon plein écran.
      if (this.props.fallback !== undefined) return this.props.fallback;
      return (
        <div style={wrap} role="alert">
          <div style={card}>
            <h1 style={{ fontSize: '20px', margin: 0 }}>Une erreur est survenue</h1>
            <p style={{ color: '#64748b', marginTop: '10px', lineHeight: 1.5 }}>
              Veuillez recharger la page. Si le problème persiste, contactez le support.
            </p>
            <button style={btn} onClick={() => window.location.reload()}>Recharger</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
